<template>
    <div>
        <!-- 查询 -->
        <div class="searchPanel">
            <SearchForm 
                :class="{queryForm_en:lang == 'en', queryForm_zh:lang == 'zh'}" 
                :form="queryForm"
                @handleInputChange="handleInputChange"
                @handlePressEnter="handleQueryPressEnter"
            ></SearchForm>
        </div>

        <Table
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
            <!-- 表格列自定义列内容 -->
            <!-- <template v-slot:customCol="{props}">
                <template v-if="props.column.key == 'status'">
                    <div class="editable-cell"> 
                        <a-tag
                            :color="props.record.status_val == 0 ? 'green' : props.record.status_val == 1 ? 'blue' : 'default' "
                        >{{ props.record.status }}</a-tag>
                    </div>
                </template>
                <template v-if="props.column.key == 'environment'">
                    <div class="editable-cell"> 
                        <a-tag
                            :color="props.record.environment_val == 0 ? 'green' : 'orange'"
                        >{{ props.record.environment }}</a-tag>
                    </div>
                </template>
            </template> -->

            <!-- 表格操作按钮 -->
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <!-- <a-button type="link" size="small" :disabled="props.record.status_val == 2" style="margin-right:10px" @click="handle('download',props.record)">
                        {{$t('base.download')}}
                    </a-button> -->
                </template>
            </template>
        </Table>

        <!-- 上传固件 -->
        <!-- <a-modal 
            v-model:visible="visible" 
            :title="t('user.editPassword')" 
            width="700px"
            @cancel="handleCancel"
            @ok="handleOk"
        >
            <a-form layout="vertical" :model="formState" >
                <a-form-item :label="t('firmware.file_desc')" v-bind="validateInfos.firmware_desc">
                    <a-input v-model:value="formState.firmware_desc" :maxlength="1000" />
                </a-form-item>
                <a-form-item v-bind="validateInfos.file">
                    <a-upload
                        class="uploadFirmware"
                        v-model:file-list="fileList"
                        name="file"
                        action=""
                        accept=".bin"
                        maxCount="1"
                        @change="handleChange"
                    >
                        <a-button>
                            <upload-outlined></upload-outlined>上传固件
                        </a-button>
                    </a-upload>
                </a-form-item>
            </a-form>
        </a-modal> -->
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, watch } from "vue";
    import Table from "@/components/Table.vue";
    import SearchForm from "@/components/Form.vue";
    import { useRouter } from "vue-router";
    import { QueryForm } from './js/formConfig.js';
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
    import { FaultApi } from '@/api/FaultApi.js';
    import { debounce } from 'lodash-es';
    import { Form } from 'ant-design-vue';

    const { t } = useI18n()
    const router = useRouter()

    const useForm = Form.useForm
    const queryForm = reactive(QueryForm)
    const visible = ref(false)
    const detail = ref(null)
    const table = ref({
        data: [],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                key: 'serial',
                width: 70,
                resizable: true,
                fixed: 'left',
            },
            {
                title: t('fault.fault_name'),
                dataIndex: 'fault_name',
                key: 'fault_name',
                width: 100,
                resizable: true,
                locel:'fault.fault_name',
            },
            {
                title: t('fault.solution'),
                dataIndex: 'solution',
                key: 'solution',
                width: 220,
                resizable: true,
                ellipsis :true,
                locel:'fault.solution',
            },
            {
                title: t('fault.chip_id'),
                dataIndex: 'chip_id',
                key: 'chip_id',
                width: 160,
                resizable: true,
                locel:'fault.chip_id',
            },
            {
                title: t('fault.create_time'),
                dataIndex: 'create_time',
                key: 'create_time',
                width: 100,
                resizable: true,
                locel:'fault.create_time',
            },
            // {
            //     title: t('base.operate'),
            //     key: 'action',
            //     fixed: 'right',
            //     width: 160,
            //     resizable: true,
            // },
        ],
        configs: {
            table: {
                pagination: {
                    total: 0,
                },
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1500,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: true,
            pagination: {
                hideOnSinglePage: false,
                position: ['bottomLeft'],
                responsive: true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '50'],
                total: 0,
                showTotal: () => t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    // const formState = reactive({
    //     firmware_desc:'',
    //     file:null,
    // })
    // const rulesRef = reactive({
    //     firmware_desc: [
    //         {
    //             required: true,
    //             message: '固件描述不能为空！',
    //         },
    //     ],
    //     file: [
    //         {
    //             required: true,
    //             message: '请上传固件！',
    //         },
    //     ]
    // })
    // const fileList = ref([])

    const handleInputChange = debounce((val, key)=>{
        // console.log(val,'vvv')
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }, 1000)

    const handleQueryPressEnter = (val, key)=>{
        // console.log(val,'vvv')
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }

    // 分页
    function handleChangePagination(config, data) {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }

    const handle = (type, row)=>{
        switch(type){
            case 'add':
                visible.value = true
                fileList.value = []
                resetFields()
                break;
            case 'download': // 下载固件
                // row.disabled = true
                // message.success(t('base.downlaoding'))
                // table.value.configs.loading = true
                // let token = localStorage.getItem('hd_ota_token')
                // let url = `${row.download_path}?Authorization=Bearer ${token}`
                // let a = document.createElement('a')
                // a.href = url
                // a.style.display = 'none'
                // document.body.appendChild(a)
                // a.click()
                // document.body.removeChild(a)
                // setTimeout(()=>{
                //     row.disabled = false
                //     table.value.configs.loading = false
                // },1500)
                break;
        }
    }

    // 获取固件列表
    const getList = async () => {
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize

        table.value.configs.loading = true
        let res = await FaultApi.getInstance().getFaultList(page_num, page_size, queryForm.formData.chip_id)
        if (res.code == 0) {
            let data = res.data
            data.records.forEach((i, index) => {
                i.serial = index + 1
                i.download_path = i.file_url == undefined? '-' : import.meta.env.VITE_BASE_URL + i.file_url
            })
            table.value.configs.pagination.total = data.total
            table.value.configs.pagination.current = data.current
            table.value.data = data.records

            table.value.configs.loading = false
        } else {
            message.error(res.msg);
        }
    }

    // // 上传固件回调
    // const handleChange = (val)=>{
    //     formState.file = val.file.originFileObj
    // }

    // 新增固件
    // const { resetFields, validate, validateInfos } = useForm(formState, rulesRef, {});
    // const handleOk = async (row)=>{
    //     validate().then(async () => {
    //         let formData = new FormData()
    //         formData.append('file', formState.file)

    //         let res = await FirmwareApi.getInstance().addFirmware(formData, formState.firmware_desc)
    //         if (res.code == 0) {
    //             message.success('固件上传成功！')
    //             visible.value = false
    //             table.value.configs.pagination.current = 1
    //             getList()
    //         } else {
    //             message.error(res.msg);
    //         }
    //     }).catch(err => {
    //         console.log('error', err);
    //     })
    // }
    // const handleCancel = ()=>{
    //     resetFields()
    // }

    //  取消固件
    // const cancelFirmware = async (row)=>{
    //     let param = {
    //         id: row.id,
    //     }
    //     let res = await FirmwareApi.getInstance().cancelFirmware(param, row.id)
    //     if (res.code == 0) {
    //         table.value.configs.pagination.current = 1
    //         getList()
    //     } else {
    //         message.error(res.msg);
    //     }
    // }

    onMounted(()=>{
        getList()
    })

</script>

<style lang="scss" scoped>
.searchPanel{
    margin-bottom: 5px;
    background: #fff;
    border-bottom: 1px dashed #ddd;

    ::v-deep .ant-form-item{
        margin-bottom: 4px;
    }
}

.detail_item{
    padding: 10px 0;
    .label{
        font-size:14px;
        font-weight: 600;
    }

    .value{
        color: #666;
    }
}

.uploadFirmware{
    ::v-deep .anticon-delete{
        display: none;
    }

    ::v-deep .ant-upload-list-item-name,
    ::v-deep .anticon-paper-clip{
        color: #1890ff;
    }

    ::v-deep .ant-upload-list-item-name{
        overflow: visible;
    }
}

::v-deep .ant-table tfoot>tr>td, 
::v-deep .ant-table tfoot>tr>th, 
::v-deep .ant-table-tbody>tr>td, 
::v-deep .ant-table-thead>tr>th {
    overflow-wrap: break-word;
    padding: 14px;
    position: relative;
}
</style>